import React, { useEffect, useState } from "react";
import TableOne from "../table/TableOne";
import { getRequest, putRequest } from "../api/api"; // if you don't have putRequest, see note below
import { Avatar, message } from "antd";
import { Dropdown, Tooltip } from "antd";
import {
  DownOutlined,
  CheckOutlined,
  LoadingOutlined,
  // EnvironmentOutlined,
} from "@ant-design/icons";
import { FaUsers } from "react-icons/fa";
const Users = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [updatingId, setUpdatingId] = useState(null); // show loader on the select being updated

  const fetchUsers = async () => {
    setLoading(true);
    try {
      const res = await getRequest("users");
      const list = res?.users || res?.data?.users || res || [];
      const formatted = list.map((u) => ({
        ...u,
        key: u?.id,
        fullName: [u?.first_name, u?.middle_name, u?.last_name]
          .filter(Boolean)
          .join(" "),
        // Use name fields if you have them; otherwise keep codes
        location: [
          u?.city_name || u?.city,
          u.state_name || u?.state,
          u?.country_name || u?.country,
        ]
          .filter(Boolean)
          .join(", "),
      }));
      setUsers(formatted);
    } catch (e) {
      console.error(e);
      message.error("Failed to load users");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const handleStatusChange = async (userId, status) => {
    setUpdatingId(userId);
    try {
      (await putRequest?.(`user/status/${userId}`, { status })) ?? // if you have putRequest
        Promise.reject(new Error("putRequest missing"));
      // Update local state
      setUsers((prev) =>
        prev.map((u) => (u.id === userId ? { ...u, is_active: status } : u))
      );
      message.success("User status updated");
    } catch (e) {
      // Fallback if you don't have putRequest in your api helper:
      // import axios and use:
      // await axios.put(`${BASE_URL}/user/status/${userId}`, { status }, { headers: { Authorization: `Bearer ${token}` } })
      console.error(e);
      message.error("Failed to update status");
    } finally {
      setUpdatingId(null);
    }
  };

  // put this helper above the component (or inside it)
  const formatTimeFirstDate = (iso) => {
    if (!iso) return "-";
    const d = new Date(iso);
    if (isNaN(d)) return "-";
    const pad = (n) => String(n).padStart(2, "0");

    const hrs = d.getHours();
    const h12 = ((hrs + 11) % 12) + 1;
    const ampm = hrs >= 12 ? "PM" : "AM";
    const time = `${pad(h12)}:${pad(d.getMinutes())} ${ampm}`;

    const date = `${pad(d.getDate())}/${pad(
      d.getMonth() + 1
    )}/${d.getFullYear()}`;
    return `${time} - ${date}`; // e.g., "04:52 AM · 03/07/2025"
  };

  const StatusPill = ({ active, loading }) => {
    const color = active ? "#10b981" : "#ef4444"; // green / red
    return (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 8,
          padding: "4px 10px",
          borderRadius: 16,
          border: `1px solid ${color}33`,
          background: `${color}12`,
          color,
          fontWeight: 600,
          cursor: loading ? "not-allowed" : "pointer",
          userSelect: "none",
        }}
      >
        <span
          style={{
            width: 8,
            height: 8,
            borderRadius: "50%",
            backgroundColor: color,
            display: "inline-block",
          }}
        />
        {active ? "Active" : "Inactive"}
        {loading ? (
          <LoadingOutlined style={{ fontSize: 12 }} />
        ) : (
          <DownOutlined style={{ fontSize: 10 }} />
        )}
      </span>
    );
  };

  const getName = (v) => {
    if (v == null) return null; // null or undefined
    if (typeof v === "object") return v?.name ?? null;
    if (typeof v === "string" && !v.trim()) return null;
    return v; // plain non-empty string
  };

  const columns = [
    {
      title: "Sr. No.",
      key: "index",
      width: 60,
      render: (_, __, index) => index + 1,
    },
    {
      title: "User",
      key: "user",
      width: 300,
      sorter: (a, b) =>
        String(a.fullName || "").localeCompare(
          String(b.fullName || ""),
          undefined,
          { sensitivity: "base" }
        ),
      render: (_, record) => (
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <Avatar
            size={40}
            src={
              record.profile_image_url ? record.profile_image_url : "/user.svg"
            }
          />
          <div>
            <div style={{ fontWeight: 600 }}>{record.fullName || "NA"}</div>
            <div style={{ fontSize: 12, color: "#888" }}>{record.email}</div>
          </div>
        </div>
      ),
    },
    {
      title: "Qualification",
      key: "qualification",
      sorter: (a, b) =>
        String(a.current_qualification || "").localeCompare(
          String(b.current_qualification || ""),
          undefined,
          { sensitivity: "base" }
        ),
      width: 240,
      render: (_, r) => {
        const q = r.current_qualification?.trim();
        const inst = r.institution_name?.trim();
        if (!q && !inst) return "NA";
        return (
          <div style={{ lineHeight: 1.25 }}>
            <div style={{ fontWeight: 600 }}>{q || "NA"}</div>
            <div style={{ fontSize: 12, color: "#666" }}>{inst || "NA"}</div>
          </div>
        );
      },
    },

    //     {
    //       title: "Role",
    //       dataIndex: "role",
    //       key: "role",
    //       width: 110,
    //       render: (val) => {
    //         const map = { U: "User", A: "Admin", S: "Super Admin" };
    //         return <Tag color="blue">{map[val] || val || "-"}</Tag>;
    //       },
    //     },
    {
      title: "Type",
      dataIndex: "student_or_practitioner",
      key: "student_or_practitioner",

      render: (v) => v || "NA",
    },

    {
      title: "Gender",
      dataIndex: "gender",
      key: "gender",
    },

       {
      title: "P Coin",
      dataIndex: "total_score",
      key: "total_score",

      render: (v) => v || "NA",
    },
       {
      title: "Mobile No.",
      dataIndex: "mobile_no",
      key: "mobile_no",

      render: (v) => v || "NA",
    },

    {
      title: "DOB",
      dataIndex: "dob",
      key: "dob",

      render: (v) => v || "NA",
    },

    //     {
    //       title: "Provider",
    //       dataIndex: "social_login_provider",
    //       key: "social_login_provider",
    //       width: 120,
    //       render: (v) => (v ? <Tag>{v}</Tag> : "-"),
    //     },


    {
      title: "Location",
      key: "location",
      ellipsis: true,
      render: (_, r) => {
        const city = getName(r.city);
        const state = getName(r.state);
        const country = getName(r.country);
        const parts = [city, state, country].filter(Boolean);
        const label = parts.length ? parts.join(", ") : "NA";

        return (
          <Tooltip title={label}>
            <span
              style={{ display: "inline-flex", alignItems: "center", gap: 6 }}
            >
              {/* <EnvironmentOutlined /> */}
              <span>{label}</span>
            </span>
          </Tooltip>
        );
      },
    },
        {
      title: "Register",
      dataIndex: "created_at",
      key: "created_at",
      sorter: (a, b) => new Date(a.created_at) - new Date(b.created_at), // ✅ date sort
      render: (val) => <span>{formatTimeFirstDate(val)}</span>,
    },
    {
      title: "Active",
      dataIndex: "is_active",
      key: "is_active",
      width: 150,
      render: (val, record) => {
        const active = val === "Y";
        const menuItems = [
          {
            key: "Y",
            label: (
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <span
                  style={{
                    width: 8,
                    height: 8,
                    borderRadius: "50%",
                    background: "#10b981",
                  }}
                />
                <span style={{ flex: 1, color: "#0f766e" }}>Active</span>
                {active && <CheckOutlined style={{ color: "#10b981" }} />}
              </div>
            ),
          },
          {
            key: "N",
            label: (
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <span
                  style={{
                    width: 8,
                    height: 8,
                    borderRadius: "50%",
                    background: "#ef4444",
                  }}
                />
                <span style={{ flex: 1, color: "#b91c1c" }}>Inactive</span>
                {!active && <CheckOutlined style={{ color: "#ef4444" }} />}
              </div>
            ),
          },
        ];

        return (
          <Dropdown
            disabled={updatingId === record.id}
            trigger={["click"]}
            menu={{
              items: menuItems,
              onClick: ({ key }) => {
                if (key !== (active ? "Y" : "N")) {
                  handleStatusChange(record.id, key); // calls PUT /user/status/:id { status: key }
                }
              },
            }}
          >
            <span>
              <StatusPill active={active} loading={updatingId === record.id} />
            </span>
          </Dropdown>
        );
      },
    },
  ];

  return (
    <div style={{ padding: 20 }}>
      <div className="header-button" style={{ marginBottom: 16 }}>
        <h2
          style={{
            margin: 0,
            color: "#5a355a",
            display: "flex",
            alignItems: "center",
            gap: "10px",
            lineHeight: 1,
          }}
        >
          <FaUsers />
          <span>All Users</span>
          <span
            style={{
              color: "#979797ff",
              fontSize: "14px",
              fontWeight: 500,
              alignSelf: "flex-end", // bottom-align just the total
            }}
          >
            (Total: {users?.length ?? 0})
          </span>
        </h2>
      </div>

      <TableOne
        columns={columns}
        data={users}
        loading={loading}
        pageName="users"
        searchWholeWord={false}
        // 👇 ensure these fields are definitely indexed
        // ✅ include all fields you want searchable (additive)
        searchIncludeFields={[
          "fullName",
          "email",
          "student_or_practitioner",
          "gender",
          "location",
          "created_at",
        ]}
      />
    </div>
  );
};

export default Users;
